import React from 'react';
import './PromotionActiveToggle.css';

export default function PromotionActiveToggle({
  active,
  loading,
  disabled,
  onToggle,
  label,
}) {
  const isDisabled = !!disabled || !!loading;

  return (
    <button
      type="button"
      className={`promo-active-toggle ${active ? 'promo-active-toggle--on' : 'promo-active-toggle--off'} ${loading ? 'promo-active-toggle--loading' : ''}`}
      onClick={onToggle}
      disabled={isDisabled}
      aria-pressed={!!active}
      aria-label={label}
      title={label}
    >
      <span className="promo-active-toggle-track" aria-hidden="true">
        <span className="promo-active-toggle-thumb" aria-hidden="true">
          {loading ? <span className="promo-active-toggle-spinner" aria-hidden="true" /> : null}
        </span>
      </span>
    </button>
  );
}

